var checkConsent = document.querySelectorAll('.ob-newsletter-checkbox-terms');
var btnNewsletter = document.querySelector('.newsletter-button');
var input = document.querySelector('.newsletter-email-input-field');

[].forEach.call(checkConsent, function(el) {
	el.addEventListener('change', function() {
		var checked = document.querySelectorAll('.ob-newsletter-checkbox-terms:checked');
		buttonHandler(checked, input);
	});
});

input.addEventListener('keyup', () => {
	var checked = document.querySelectorAll('.ob-newsletter-checkbox-terms:checked');
	buttonHandler(checked, input);
});

function buttonHandler(checkbox, input) {
	if (checkbox.length && input.value) {
		btnNewsletter.style.background = '#237570';
	} else {
		btnNewsletter.style.background = '';
	}
}

document.querySelector('.newsletter__form').addEventListener('submit', () => {
	sessionStorage.setItem('customerRegistered', 'newsletter');
});
